export default __webpack_public_path__ + "static/media/06.1c1a1ef6.webp";